import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import errorToast from "../../components/helper-components/error-toast";
import { selfDeclarationViewAction } from "../../redux/actions/store-action";
import SelfDeclarationView from "../../components/store-information/self-declaration/self-declaration-view";

const ViewSelfDeclaration = () => {
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [declaration, setDeclaration] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(selfDeclarationViewAction(id, onSuccess, onError));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onSuccess = (data) => {
    const record = data?.data ?? {};
    setDeclaration(record);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message ?? data?.data?.message ?? "Failed to load self declaration");
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          page="view"
          title={"View Self Declaration"}
          title1={declaration?.franchisee_name}
        >
          <SelfDeclarationView
            declaration={declaration}
            permissionFn={permissionFn}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewSelfDeclaration;
